export default [
  [
    "nl",
    {
      title: "StrokenCalculator",
      task1: "Geef hieronder de gewenste maat aan:",
      task2: " cm",
      tv1: "Gordijnbreedte",
      tv2: "Strookbreedte",
      tv3: " haken",
      tv4: "Alle",
      tv5: "Aantal stroken",
      tv6: "alle opties",
      tv7: "Soort ",
      tv8: "proportie",
      tv9: "Overlap",
      tv10: "overlap",
      tv11: "standaard",
      tv12: "minimaal",
      tv13: "gemiddeld",
      tv14: "gemiddeld+",
      tv15: "maximaal",
      tv16: " : ",
      submit: "Bereken aantal stroken",
      load1: "Resultaten worden geladen....",
      load2: "Het is aan het laden....",
      load3: "Geen resultaten",
    },
  ],
  [
    "en",
    {
      title: "Strip Calculator",
      task1: "Please indicate the desired size below",
      task2: " cm",
      tv1: "Curtainwidth",
      tv2: "Stripwidth",
      tv3: " hooks",
      tv4: "All",
      tv5: "Number of strips",
      tv6: "all options",
      tv7: "Type of ",
      tv8: "proportion",
      tv9: "Overlap",
      tv10: "overlap",
      tv11: "standaard",
      tv12: "minimum",
      tv13: "averidge",
      tv14: "averidge+",
      tv15: "maximum",
      tv16: " : ",
      submit: "Calculate the number of strips",
      load1: "Results are loading....",
      load2: "It's loading....",
      load3: "No results",
    },
  ],
  [
    "de",
    {
      title: "Streifen Calculator",
      task1: "Bitte geben Sie unten die gewünschte Größe an",
      task2: " cm",
      tv1: "Vorhangbreite",
      tv2: "Streifenbreite",
      tv3: " haken",
      tv4: "Alle",
      tv5: "Anzahl der Streifen",
      tv6: "alle Optionen",
      tv7: "Art der ",
      tv8: "Proportion",
      tv9: "Übberlappung",
      tv10: "übberlappung",
      tv11: "standaard",
      tv12: "mindestens",
      tv13: "durchschnitt",
      tv14: "durchschnitt+",
      tv15: "maximale",
      tv16: " : ",
      submit: "Berechnen Sie die Anzahl der Streifen",
      load1: "Ergebnisse werden geladen....",
      load2: "Es lädt....",
      load3: "Keine Ergebnisse",
    },
  ],
  [
    "fr",
    {
      title: "Calculateur de Lanières",
      task1: "Veuillez indiquer la taille souhaitée ci-dessous",
      task2: " cm",
      tv1: "Largeur du rideau",
      tv2: "Largeur du lanière",
      tv3: " crochets",
      tv4: "Toutes",
      tv5: "Nombre de lanières",
      tv6: "tous",
      tv7: "Type de ",
      tv8: "proportion",
      tv9: "Chevauchement",
      tv10: "chevauchement",
      tv11: "standard",
      tv12: "minimale",
      tv13: "moyenne",
      tv14: "moyenne+",
      tv15: "maximale",
      tv16: " : ",
      submit: "Calculer le nombre de lanières",
      load1: "Les résultats sont en cours de chargement....",
      load2: "Ça charge....",
      load3: "Sans résultats",
    },
  ],
];
